import { config } from '../../common/theme/gluestack-ui.config';

export const tabScreenOptions = {

  tabBarStyle: {
    backgroundColor: 'transparent',
  },
  tabBarLabelStyle: {
    textTransform: 'none', // Normal case
  },
  tabBarItemStyle: {
    alignItems: 'center', // Left align the tab items
    minWidth: 0,
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 6,
    minHeight: 32,
  },
  tabBarIndicatorStyle: {
    bottom: -1,
    backgroundColor: config.tokens.colors.textLight900, // Active tab indicator color
  },
  tabBarIndicatorContainerStyle: {
  },
  tabBarActiveTintColor: config.tokens.colors.textLight900,
  tabBarInactiveTintColor: config.tokens.colors.textLight500,
  tabBarScrollEnabled: true,
  swipeEnabled: false,
};
